<script>
  import Hero from "./Hero.svelte";
  import About from "./About.svelte";

  import WebDev from "./WebDev.svelte";
  import Designs from "./Music.svelte";

  import Contact from "./Contact.svelte";

  export let theme;
</script>

<main class="snap-y">
  <Hero bind:theme />
  <About />
  <WebDev />
  <Designs />
  <Contact />
</main>
